import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import alertIcon from '../../../../img/warning-icon.svg';
import { Button, Divider } from '@mui/material';
import { useGetResourcesHeadersQuery, useSortResourcesHeadersMutation } from '../../../../services/resourcesApi';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { useNotification } from '../../../../context/NotificationContext';
import { createErrorMessage } from '../../../../utils';
import { useState } from 'react';
import { useEffect } from 'react';

const style = {
  position: 'absolute',
  marginLeft: `calc(50vw - 20vw)`, // 200px es la mitad del ancho (width)
  width: '40vw',
  marginTop: `calc(50vh - 125px)`, // 200px es la mitad del alto (height)
  height: '250px',
  bgcolor: 'background.paper',
  border: 'none',
  borderRadius: '2em',
  boxShadow: 24,
  p: 4,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
};

const listStyle = {
  width: '100%',
  display: 'flex',
  padding: 8,
  overflow: 'auto',
};

export default function ResourceHeaderOrderModal(props) {

  const { showNotification } = useNotification();

  const { data, error, isLoading, isFetching } = useGetResourcesHeadersQuery();
  const [sortResourcesHeaders] = useSortResourcesHeadersMutation();
  const [stateResourcesHeaders, setStateResourcesHeaders] = useState([]);
  const [oldStateOrder, setOldStateOrder] = useState([]);

  useEffect(()=>{
    setStateResourcesHeaders([...(JSON.parse(JSON.stringify(data)) || [])]);
    setOldStateOrder([...(JSON.parse(JSON.stringify(data)) || [])]);
  },[data])

  function orderHasChanged(){
    
    let testResult= oldStateOrder.every((resourceHeader, index) => {
      let idExpected= resourceHeader.id;
      let idNow= stateResourcesHeaders[index].id;
      console.log("idExpected: ", idExpected , " idNow: ", idNow);
      return idExpected === idNow;
    });

    return !testResult; //if true means that that order not changed, so return false
  }

  function createOrderedEditObjects(){
    return stateResourcesHeaders.map((resourceHeader, index) => {
      return {id: resourceHeader.id, orderNumber: index};
    });
  }

  async function onSaveClick(){
    console.log("saving new order...");
    //DBG
    // console.log("oldStateOrder: ", oldStateOrder);
    // console.log("stateResourcesHeaders: ", stateResourcesHeaders);
    if(orderHasChanged()){
      console.log("order changed reAssignOrderNumber");
      let editObject= createOrderedEditObjects();
      console.log("stateResourcesHeaders: ", editObject);
      try {
        await sortResourcesHeaders(editObject).unwrap();
        showNotification('Resources Headers order updated successfully', 'success');
      } catch (error) {
        console.log("error: " , error);
        showNotification(createErrorMessage(error), 'error');
      }
    }
  }

  function onCancelClick(){
    props.handleClose();
  }

  if(error){
    return <div>{error}</div>
  }

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
  
    return result;
  };

  const onDragEnd= (result)=> {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const items = reorder(
      stateResourcesHeaders,
      result.source.index,
      result.destination.index
    );

    setStateResourcesHeaders([...items]);
  }

  return (
    <div>
      <Modal
        open={props.open}
        onClose={onCancelClick} 
        id= "resourcesHeaders"
      >
        <Box sx={style}>
          <h3 style={{color: "var(--orange)"}}>Sub-Page Headers Order List</h3>

          
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="resourcesHeaders" direction="horizontal">
              {(provided) => (
                <div {...provided.droppableProps}  ref={provided.innerRef} style={{...listStyle}} >
                  {(stateResourcesHeaders).map((resourceHeader, index) => (
                    <Draggable
                    
                      key={resourceHeader.id}
                      draggableId={`${resourceHeader.id}`}
                      index={index}
                    >
                      {(provided) => (
                        <div
                        
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                        >
                          <div key={resourceHeader.id} style={{margin: "0 1em 0 0"}}>
                            <Typography id="modal-modal-description" sx={{ mt: 2 }} align="center">
                              {resourceHeader.name}
                            </Typography>
                          </div>
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>

          <div className='basic-modal-button'>
            <Button
              variant='contained'
              color='secondary'
              onClick={onCancelClick}
              style={{ margin: '0 2em 0 0', width:'100px' }}
            >
              {"Cancel"}
            </Button>

            <Button variant='contained' style={{ width:'100px' }} onClick={onSaveClick}>Save</Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}